import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import NProgress from '@plugins/_nprogress';
import store from '@store/index';
import { isNotEmpty } from '@helpers/validation';

Vue.use(VueRouter);

const whitePathList = [
    'Login',
    'ForgetPassword',
    'HomePage',
    'Register',
    'PlaybackPlayer',
    'PublicClass'
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
    linkExactActiveClass: 'is-active',
    scrollBehavior(_to, _from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, _from, next) => {
    NProgress.start();
    const token = store.getters.token;
    if (whitePathList.includes(to.name) || isNotEmpty(token)) {
        next();
    } else {
        next({
            name: 'Login',
            query: {
                redirectUrl: to.fullPath
            }
            // replace: true
        });
    }
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;
